import { useTheme } from '@mui/material/styles';
import type { ChromeTokens } from '@eis/theme';

/**
 * The chrome variant the shell is rendering, read off the theme (SDD-012, U-2).
 *
 * Only chrome components call this. A module or a pattern that wanted to know the variant would
 * be a component that looks different per variant, which is the thing a variant must never be —
 * the boundary matrix keeps the import from happening, and this hook living in `chrome/` keeps
 * the temptation out of sight.
 */
export function useChromeVariant(): ChromeTokens {
  return useTheme().eis;
}
